import _ from "lodash";
import { ACTIONS } from "UTILS/Constants";

const initialState = {
  messages: [],
  isMessageArrived: false,
  showMessageToast: false,
  messagesRead: false
};
export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CHAT.SET_MESSAGES:
      let isMessageArrived =
        action.messages && action.messages.length !== 0 ? true : false;
      return {
        ...state,
        messages: action.messages,
        showMessageToast: isMessageArrived,
        isMessageArrived: isMessageArrived
      };
      break;
    case ACTIONS.CHAT.ADD_MESSAGE:
      let messages = _.cloneDeep(state.messages);
      messages.push(action.messageDetails);
      return {
        ...state,
        messages: messages
      };
      break;
    case ACTIONS.CHAT.DISPLAY_MESSAGE:
      return {
        ...state,
        isMessageArrived: action.messageDisplay
      };
      break;
    case ACTIONS.CHAT.SET_MESSAGES_READ:
      return {
        ...state,
        messagesRead: action.value
      };
      break;
    case ACTIONS.CHAT.MESSAGE_ARRIVED:
      return {
        ...state,
        showMessageToast: action.value
      };
    case ACTIONS.LEAVE_SESSION_LOCAL:
      return {
        ...state,
        isMessageArrived: false
      }
    case ACTIONS.LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}
